// The map editor's mouse in output px, held outside Redux: with Show on output, every output draws a cross there.
let at = null
let memo = [undefined, undefined, null]
const listeners = new Set()

export const mapCursor = () => at

/** `p`: `[x, y]` in output px, or null when the mouse is off the output. */
export const setMapCursor = p => {
	if (p === at || (p && at && p[0] === at[0] && p[1] === at[1])) return
	at = p
	for (const cb of listeners) cb()
}

export const subscribeMapCursor = cb => {
	listeners.add(cb)
	return () => listeners.delete(cb)
}

/** `guides` (`selectShownGuides`) with the cursor as `cursor`; one object per guides and cursor, so a renderer redraws on a change only. */
export const guidesWithCursor = guides => {
	if (memo[0] !== guides || memo[1] !== at) memo = [guides, at, guides && at ? { ...guides, cursor: at } : guides]
	return memo[2]
}
